import { ApiBaseUrls, CORE_BASE_URLS } from 'plmt-core-library';

export const apiBaseUrls: ApiBaseUrls = {
    ...CORE_BASE_URLS,
    project: '/proxy/manager/api',
};
